import React, { useEffect } from "react";
import NoTestAvail from "../../components/noTestAvailable/noTesAvail";
import { HelperContext } from "../../store/helperStore";

export default function SimpleSoundReaction({ questions, index }) {
  const { helperC, dispatchHelper } = HelperContext();

  const handleNext = (nextTest) => {
    dispatchHelper({
      type: "RUNNING_QUES_ID",
      payload: nextTest.id,
    });
  };

  const handleSubmit = () => {
    dispatchHelper({
      type: "RUNNING_QUES_ID",
      payload: "submitted",
    });
  };

  console.log("helperC.type === CALIBRATION", helperC.type === "CALIBRATION");
  console.log("helperC.type", helperC.type);

  useEffect(() => {
    if (helperC.type === "CALIBRATION") {
      index < questions.length - 1
        ? handleNext(questions[index + 1])
        : handleSubmit();
    }
  }, []);

  return (
    <>
      {helperC.type !== "CALIBRATION" ? (
        <NoTestAvail />
      ) : (
        <div className="">
          <div className="">Simple Sound Reaction</div>
        </div>
      )}
    </>
  );
}
